/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import styles from "./videoPanel.module.scss";
import { withVideoTools } from "../../shared/containers/containerVideoTools";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import getDates from "../../shared/services/date.service";

class VideoPanel extends Component {
  onClose() {
    const { onSetStateVideoPanel } = this.props;
    onSetStateVideoPanel(false, null, true, null, null, 0);
  }

  getChannelsPrametr() {
    const { channels } = this.props;

    const concatString = (prm, value) => {
      return prm.length > 0 ? `_${value}` : value;
    };

    let parametr = "";
    if ((channels & 1) !== 0) {
      parametr += concatString(parametr, "1");
    }

    if ((channels & 2) !== 0) {
      parametr += concatString(parametr, "2");
    }

    if ((channels & 4) !== 0) {
      parametr += concatString(parametr, "3");
    }

    if ((channels & 8) !== 0) {
      parametr += concatString(parametr, "4");
    }

    return parametr;
  }

  getDateFormat() {
    const { isOnlineVideo, dateStart, dateEnd } = this.props;

    if (isOnlineVideo) return null;

    const start = getDates.getDateFormat13(dateStart);
    const end = getDates.getDateFormat13(dateEnd);

    return { start, end };
  }

  render() {
    const { isOpenVideoPanel, isOnlineVideo, dateStart, dateEnd, deviceId, token, speedPlay } = this.props;

    if (!isOpenVideoPanel) return null;

    const height = window.innerHeight > 800 ? 500 : 400;
    const width = window.innerHeight > 800 ? 800 : 550;
    const chs = this.getChannelsPrametr();

    const date = this.getDateFormat();
    const url = isOnlineVideo
      ? `https://vss.videosat.by/vss/apiPage/RealVideo.html?token=${token}&deviceId=${deviceId}&chs=${chs}&stream=0&wnum=4&panel=1&buffer=2000`
      : `https://vss.videosat.by/vss/apiPage/ReplayVideo.html?token=${token}&deviceId=${deviceId}&chs=${chs}&st=${date.start}&et=${date.end}&wnum=4&panel=1&speed=${speedPlay}&buffer=3000`;

    return (
      <div className={styles.videoPanelContainer} key={token + isOpenVideoPanel + isOnlineVideo} style={{ width: `${width}px` }}>
        <div className={styles.customPanel}>
          {isOnlineVideo ? (
            <b>Онлан просмотр</b>
          ) : (
            <b>{`Просмотр с ${getDates.getDateFormat14(dateStart)} по ${getDates.getDateFormat14(dateEnd)} `}</b>
          )}
          <HighlightOffIcon onClick={this.onClose.bind(this)} style={{ color: "red", cursor: "pointer" }} />
        </div>

        <iframe src={url} width={width} height={height} />
      </div>
    );
  }
}

export default withVideoTools(React.memo(VideoPanel));
